import dayjs from 'dayjs';
import TransactionLink from "bukku/components/TransactionLink";
import React from 'react';
import TransactionType from "bukku/components/TransactionType";
import AmountTd from "bukku/components/Table/Common/AmountTd";
import BukkuTooltip from "bukku/components/Tooltip";
import {ConditionalTooltip} from "../../../../components/Tooltip/ConditionalTooltip";
import {ColRenderer} from '../TransactionSummary/Common/helperColRenderer';
import ContactName from 'bukku/components/Columns/Reports/Common/ContactName';

export const Helper = {
    renderDate: ({ rowData }) => {
        if (rowData.colType === 'subtotal') {
            return (
                <div className="indent-col">
                    {rowData.label}
                </div>
            );
        }
        if (rowData.colType === 'subtotal') {
            return (
                <div className="indent-col">
                    {rowData.label}
                </div>
            );
        }
        const label = dayjs(rowData.date).format('DD/MM/YYYY');
        return (
            <TransactionLink transaction={rowData} label={label} />
        );
    },

    renderNumber: ({ rowData }) => (
        <div className="BaseTable__row-cell-text">
            <ConditionalTooltip
                rules={[{
                    condition: rowData.number !== null,
                    message: rowData.number,
                }]}
                placement="topLeft"
            >
                <span>{rowData.number || '-'}</span>
            </ConditionalTooltip>
        </div>
    ),

    renderType: ({ rowData }) => {
        if (rowData.colType === 'subtotal')
            return '';
        return (
            <div className="BaseTable__row-cell-text">
                <TransactionType record={rowData} />
            </div>
        );
    },

    renderNumber2: ({ rowData }) => {
        if (rowData.type === 'opening_balance')
            return null;

        if (rowData.type === 'opening_balance')
            return null;

        if (rowData.colType === 'subtotal')
            return '';
        return (
            <div className="BaseTable__row-cell-text">
                <ConditionalTooltip
                    rules={[{
                        condition: rowData.number2 !== null,
                        message: rowData.number2,
                    }]}
                    placement="topLeft"
                >
                    <span>{rowData.number2 || '-'}</span>
                </ConditionalTooltip>
            </div>
        );
    },

    renderContact: ({ rowData }) => {
        if (rowData.type === 'opening_balance')
            return null;

        if (rowData.colType === 'subtotal')
            return '';

        const { contact_name, contact_id, contact_code } = rowData;
        return (
            <ContactName
                contact_id={contact_id}
                contact_name={contact_name}
                contact_code={contact_code}
            />
        );
    },

    renderContact2: ({ rowData }) => {
        if (rowData.type === 'opening_balance')
            return null;

        if (rowData.colType === 'subtotal')
            return '';

        const {contact2_name, contact2_id, contact2_code} = rowData;
        return (
            <ContactName
                contact_id={contact2_id}
                contact_name={contact2_name}
                contact_code={contact2_code}
            />
        );
    },

    renderContactCode: ({ rowData }) => (
        <div className="BaseTable__row-cell-text">
            {rowData.contact_code}
        </div>
    ),

    renderContact2Code: ({ rowData }) => (
        <div className="BaseTable__row-cell-text">
            {rowData.contact2_code}
        </div>
    ),

    renderPaymentMethod: ({ rowData }) => {
        if (rowData.type === 'opening_balance')
            return null;

        if (rowData.colType === 'subtotal')
            return '';

        return (
            <div className="BaseTable__row-cell-text">
                {rowData.payment_method_name || rowData.payment_method || '-'}
            </div>
        );
    },

    renderPaymentMethods: ({ rowData }) => {
        if (rowData.colType === 'subtotal')
            return '';

        const paymentMethodsText = rowData.payment_methods
            ? rowData.payment_methods.join(", ")
            : "-";
        return (
            <div className="BaseTable__row-cell-text">
                <BukkuTooltip
                    title={paymentMethodsText}
                    // autoAdjustOverflow={false}
                    placement="topLeft"
                >
                    {paymentMethodsText}
                </BukkuTooltip>
            </div>
        );
    },

    renderDescription: ({ rowData }) => {
        if (rowData.type === 'opening_balance')
            return null;

        if (rowData.colType === 'subtotal')
            return '';

        return (
            <div className="BaseTable__row-cell-text">
                <BukkuTooltip
                    title={rowData.description}
                    // autoAdjustOverflow={false}
                    placement="topLeft"
                >
                    {rowData.description || '-'}
                </BukkuTooltip>
            </div>
        );
    },

    renderCurrencyCode: ({ rowData }) => {
        if (rowData.type === 'opening_balance')
            return null;

        if (rowData.colType === 'subtotal')
            return '';

        return (
            <div className="BaseTable__row-cell-text">
                {rowData.currency_code || '-'}
            </div>
        );
    },

    renderTitle: ({ rowData }) => {
        if (rowData.type === 'opening_balance')
            return null;

        return (
            <div className="BaseTable__row-cell-text">
                <BukkuTooltip title={rowData.title}>
                    {rowData.title || '-'}
                </BukkuTooltip>
            </div>
        );
    },

    renderCreatedAt: ({ rowData }) => {
        if (rowData.colType === 'subtotal')
            return '';

        const date = rowData.created_at;
        const dateMoment = dayjs(date, "YYYY-MM-DD HH:mm:ss");
        const dateString = dateMoment.isValid() ? dateMoment.format('DD/MM/YYYY') : undefined;
        const timeString = dateMoment.isValid() ? dateMoment.format(' h:mm a') : undefined;

        return (
            <div className="datetime">
                <div className="date">{dateString}</div>
                <div className="time">{timeString}</div>
            </div>
        );
    },

    renderAmount: (amount, currency_symbol, emptyCell = true) => {
        if (amount === '' || amount === undefined || amount === null) {
            // for money in/out in OR/PV reports
            if (emptyCell)
                return null;
            return '-';
        }
        return (
            <AmountTd
                currency_symbol={currency_symbol}
                amount={amount}
                className="amount-td"
                showTooltip
            />
        );
    },

    renderExchangeRate: ({ rowData }) => {
        const { exchange_rate: amount } = rowData;
        if (amount === '' || amount === undefined || amount === null)
            return null;

        return (
            <AmountTd
                amount={amount}
                className="amount-td"
                showTooltip
                dp={8}
            />
        );
    },

    renderTags: ({rowData}) => {
        if (rowData.colType === 'subtotal')
            return '';

        return (
            <div className="BaseTable__row-cell-text">
                {ColRenderer.renderTags(rowData.tag_names, rowData)}
            </div>
        );
    },

    rowRenderer: props => {
        const {
            columns,
            cells,
            rowData,
        } = props;

        // Override
        let className;
        let children;
        const first2ColumnFlexGrow = columns[0].flexGrow + columns[1].flexGrow;
        switch (rowData.colType) {
            case 'spacer':
                className = `${cells[0].props.className} spacer-col`;
                children = '';
                return React.cloneElement(cells[0], { className, children });
            case 'heading':
                className = `${cells[0].props.className} heading-col`;
                children = rowData.label;
                return React.cloneElement(cells[0], { className, children });
                // case 'subtotal':
                //     // flexGrow = 0;
                //     return cells.map((cell, cellIdx) => {
                //         className = `${cell.props.className} subtotal-col`;

                //         // const nonNullColumns = [
                //         //     'number2',
                //         //     'description',
                //         //     'base_debit_amount',
                //         //     'debit_amount',
                //         //     'base_credit_amount',
                //         //     'credit_amount',
                //         //     'base_amount',
                //         //     'amount',
                //         //     'balance',
                //         //     'created_at',
                //         // ];
                //         // const column = columns[cellIdx];
                //         // const isNullColumn = !nonNullColumns.find(c => c === column.key);
                //         // console.log('aaa GL cols 0', {column, isNullColumn});
                //         // if (cellIdx === 0) { // the first column
                //         // let numColumn = 0;
                //         // columns.forEach(col => {
                //         //     console.log('aaa GL cols 1', {col: col.key, isNullColumn});
                //         //     if (!nonNullColumns.find(c => c === col.key)) {
                //         //         flexGrow += col.flexGrow || 0;
                //         //         numColumn += 1;
                //         //     }
                //         // });
                //         // style = {
                //         //     ...cells[cellIdx].props.style,
                //         //     paddingLeft: 17.5,
                //         //     paddingRight: 7.5 * (2 * numColumn - 1),
                //         //     flexGrow,
                //         // };
                //         //     return React.cloneElement(cell, {
                //         //         className,
                //         //         children: (
                //         //             <div className="indent-col">
                //         //                 {rowData.label}
                //         //             </div>
                //         //         ),
                //         //         style });
                //         // }

            //         // if (isNullColumn)
            //         //     return null;
            //         return React.cloneElement(cell, {className});
            //     });
            case 'subtotal':
                // flexGrow = 0;
                return cells.map((cell, idx) => {
                    const column = columns[idx];

                    const props = {
                        className: `${cell.props.className} subtotal-col ${rowData.className || ''}`,
                    };

                    if (column.key === 'date') {
                        const colSpan = 2;
                        props.style = {
                            ...cell.props.style,
                            flexGrow: first2ColumnFlexGrow,
                            paddingLeft: 17.5,
                            paddingRight: 7.5 * (2 * colSpan - 1),
                        };
                    }
                    else if (column.key === 'number') {
                        return null;
                    }

                    return React.cloneElement(cell, props);
                });
            default:
                return cells.map((cell, cellIdx) => {
                    if (cellIdx === 0) {
                        className = `${cell.props.className} indent-col`;
                        children = (
                            <div className="indent-col">
                                {columns[cellIdx].cellRenderer({ rowData })}
                            </div>
                        );
                        return React.cloneElement(cell, {className, children});
                    }
                    return cell;
                });
        }
    },

    getWidth: (width, columns) => {
        let threshold = 0;
        columns.forEach(column => {
            threshold += column.width || 132;
        });
        return width <= threshold ? threshold : width;
    },
};
